import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef,} from '@angular/core';
import {UntypedFormControl} from "@angular/forms";
import {debounceTime, filter, finalize, switchMap, tap} from "rxjs/operators";
import {from} from "rxjs";
import {ServerService} from "../../../services/server.service";
import _ from "lodash";

@Component({
   selector: 'app-autocomplete-multiselect',
   styleUrls: ['./autocomplete-multiselect.component.scss'],
   template: `

      <div class="chip-list-wrapper px-2" style="width: 100%">
         <small class="inline-block">Selezionati:</small>
         <mat-chip-list #chipList>
            <ng-container *ngFor="let select of selectData">
               <mat-chip class="cardinal-colors" (click)="removeChip(select)">
                  <ng-container [ngTemplateOutlet]="optionChipTemplate"
                                [ngTemplateOutletContext]="{$implicit: select}"
                  ></ng-container>
                  <mat-icon class="mat-chip-remove">cancel</mat-icon>
               </mat-chip>
            </ng-container>
         </mat-chip-list>
      </div>

      <mat-form-field class="full-width px-2" [appearance]="appearance">
         <input matInput type="text"
                [placeholder]="placeholder"
                [matAutocomplete]="autocomp"
                [formControl]="inputCtrl">
      </mat-form-field>

      <mat-autocomplete #autocomp="matAutocomplete" [panelWidth]="panelWidth"
                        (optionSelected)="outputSelection($event)"
                        [displayWith]="displayFn.bind(this, rawData)">
         <mat-option *ngFor="let x of rawData"
                     [value]="x.data.id">
            <div (click)="optionClicked($event, x.data)">
               <mat-checkbox [checked]="x.data.selected"
                             (change)="toggleSelection(x.data)"
                             (click)="$event.stopPropagation()">
                  <ng-container [ngTemplateOutlet]="optionTemplate"
                                [ngTemplateOutletContext]="{$implicit: x}"
                  ></ng-container>
               </mat-checkbox>
            </div>
         </mat-option>
         <mat-option *ngIf="errorMsg" [value]="null">
            <span>{{errorMsg}}</span>
         </mat-option>
      </mat-autocomplete>
   `
})
export class AutocompleteMultiselectComponent implements OnInit, AfterViewInit {
   @Input() appearance:any = 'standard'

   @Output() result = new EventEmitter<{ key: string, data: Array<string> }>();
   @Input() placeholder: string = 'Select Data';
   @Input() data: Array<string> = [];
   @Input() key: string = '';
   @Input() outputCtrl: UntypedFormControl = new UntypedFormControl();
   @Input() classObject: any;
   @Input() url:string = ''
   @Input() optionTemplate: TemplateRef<any> | null = null;
   @Input() optionChipTemplate: TemplateRef<any> | null = null;
   @Input() rawData: Array<any> = [];
   @Input() panelWidth: number = 220;

   @Output() outputChoice = new EventEmitter<any>()
   @Output() clickNewElement = new EventEmitter<any>()

   inputCtrl: UntypedFormControl = new UntypedFormControl();
   selectData: Array<any> = [];
   selectDataId: Array<any> = [];
   isLoading: boolean = false;
   errorMsg: string = '';
   private minLengthTerm = 3;

   constructor(private serverSrv: ServerService) {

   }

   ngOnInit(): void {
      this.data.forEach((item: string) => {
         this.rawData.push({ item, selected: false });
      });
   }

   ngAfterViewInit(): void {
      console.log(this.inputCtrl.value)
      this.inputCtrl.valueChanges
         .pipe(
            debounceTime(1000),
            filter(res => {
               if (res !== null && res.length >= this.minLengthTerm) return true
               return res == null || res.length == 0
            }),
            tap(() => {
               this.errorMsg = "";
               this.rawData = [];
               this.isLoading = true;
            }),
            switchMap(v=>{
               return from(this.serverSrv.getAll(this.classObject, this.url + v
                  ).then(res => {
                     this.rawData = res
                     console.log(this.rawData)
                     _.forEach(this.rawData, x => {
                        _.find(this.selectData, y => {
                           if (x.data.id === y.id) x.data.selected = true
                        })
                     })
                  }).catch(err => {
                     console.error(err)
                  })
               ).pipe(finalize(() => {
                  this.isLoading = false
               }))
            })
         )
         .subscribe((data) => {
            this.isLoading = false
            if (this.rawData.length == 0) {
               this.errorMsg = 'Nessun elemento trovato';
               this.rawData = []
            } else {
               this.errorMsg = "";
            }
         });

   }

   displayFn = (): string => '';

   optionClicked = (event: Event, data: any): void => {
      console.log(data)
      event.stopPropagation();
      this.toggleSelection(data);
   };

   toggleSelection = (data: any): void => {
      data.selected = !data.selected;
      if (data.selected === true) {
         this.selectData.push(data);
         this.selectDataId.push(data.id);
         console.log(this.selectData)
      } else {
         const i = this.selectData.findIndex(value => value.id === data.id);
         let x = this.selectDataId.indexOf(data.id)
         this.selectData.splice(i, 1);
         this.selectDataId.splice(x, 1);
      }
      this.outputCtrl.setValue(this.selectDataId);
      this.emitAdjustedData();
   };

   emitAdjustedData = (): void => {
      const results: Array<string> = []
      this.selectData.forEach((data: any) => {
         results.push(data.item);
      });
      this.result.emit({ key: this.key, data: results });
   };

   removeChip = (data: any): void => {
      this.toggleSelection(data);
   };

   outputSelection(e) {
      this.outputChoice.emit(
         [e, this.selectData]
      )
   }
}
